import { useState, useRef } from "react";

const useRowSelection = () => {
  const [rowSelection, setRowSelection] = useState({});
  const lastSelectedRowRef = useRef(null); // ⭐ Guardamos el último seleccionado

  const handleRowSelect = (row, table, event) => {
    const currentRowId = row.id;
    const newSelection = { ...rowSelection };

    if (event.shiftKey && lastSelectedRowRef.current !== null) {
      // Si shift está presionado, seleccionamos el rango
      const rows = table.getRowModel().rows;
      const currentIndex = rows.findIndex((r) => r.id === currentRowId);
      const lastIndex = rows.findIndex((r) => r.id === lastSelectedRowRef.current);

      if (currentIndex !== -1 && lastIndex !== -1) {
        const [start, end] = [currentIndex, lastIndex].sort((a, b) => a - b);
        for (let i = start; i <= end; i++) {
          newSelection[rows[i].id] = true;
        }
      }
    } else {
      // Selección normal (un solo click)
      if (row.getIsSelected()) {
        delete newSelection[currentRowId];
      } else {
        newSelection[currentRowId] = true;
      }
      lastSelectedRowRef.current = currentRowId; // Actualizamos el último click
    }

    setRowSelection(newSelection);
    table.setRowSelection(newSelection);
  };

  const selectionColumn = {
    id: "select",
    header: ({ table }) => (
      <div className="form-check d-flex justify-content-center my-0 mx-n1">
        <input
          type="checkbox"
          className="form-check-input"
          checked={table.getIsAllRowsSelected()}
          ref={(el) => {
            if (el) el.indeterminate = table.getIsSomeRowsSelected();
          }}
          onChange={table.getToggleAllRowsSelectedHandler()}
          id={`select-all-${table.id || "main"}`}
        />
      </div>
    ),
    cell: ({ row, table }) => (
      <div className="form-check d-flex justify-content-center my-0 mx-n1">
        <input
          type="checkbox"
          className="form-check-input"
          checked={row.getIsSelected()}
          readOnly
          ref={(el) => {
            if (el) el.indeterminate = row.getIsSomeSelected();
          }}
          onClick={(e) => handleRowSelect(row, table, e)}
          id={`select-row-${row.id}`}
        />
      </div>
    ),
  };

  return { rowSelection, setRowSelection, selectionColumn };
};

export default useRowSelection;
